import React, { useState } from 'react';
import { adminApi } from '@/lib/api';

const TYPES = ['PRIMARY', 'OFFICIAL', 'REPORTING', 'RESEARCH', 'DATA', 'DISCOVERY', 'MIRROR'];
const TIERS = ['PRIMARY', 'REPORTING', 'RESEARCH', 'DISCOVERY'];
const CATEGORIES = ['ai', 'robotics', 'cybersecurity', 'future-tech', 'business', 'guides'];
export function sourceError(error) {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : 'Could not save source. Check the fields and try again.';
}
export default function SourceEditor({ source, onSaved, onCancel }) {
  const [form, setForm] = useState({ name: source?.name || '', feed_url: source?.feed_url || source?.endpoint || '',
    category: source?.category || 'ai', source_type: source?.source_type || 'REPORTING',
    source_tier: source?.source_tier || 'DISCOVERY', enabled: source?.enabled || false });
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState('');
  const update = (field, value) => { setForm(prev => ({ ...prev, [field]: value })); setFeedback(''); };
  const test = async () => {
    setBusy(true); setFeedback('');
    try {
      const result = await adminApi.testSource(form.feed_url);
      setFeedback(`Valid ${result.format} feed · HTTP ${result.http_status} · ${result.items} items. Activation rechecks the feed.`);
    } catch (error) { setFeedback(sourceError(error)); }
    finally { setBusy(false); }
  };
  const save = async event => {
    event.preventDefault(); setBusy(true); setFeedback('');
    try {
      if (source) await adminApi.editSource(source.id, form);
      else await adminApi.addSource(form);
      onSaved();
    } catch (error) { setFeedback(sourceError(error)); }
    finally { setBusy(false); }
  };
  return <section aria-label={source ? 'Edit Source' : 'Add Source'} className="rounded-lg border border-[#363a40] p-5 mb-6 bg-[#111315] text-white">
    <h2 className="font-display font-bold mb-4">{source ? 'Edit Source' : 'Add Source'}</h2>
    <form onSubmit={save}>
      <fieldset disabled={busy} className="grid sm:grid-cols-2 gap-4 disabled:opacity-60">
        {[['name', 'Publisher name'], ['feed_url', 'RSS URL']].map(([field, label]) => <label key={field} className="text-sm">{label}
          <input required type={field === 'feed_url' ? 'url' : 'text'} maxLength={field === 'feed_url' ? 2048 : 160} value={form[field]}
            onChange={e => update(field, e.target.value)} className="block mt-1 w-full rounded bg-[#1B1E21] border border-[#363a40] p-2" />
        </label>)}
        {[['category', 'Category', CATEGORIES], ['source_type', 'Source type', TYPES], ['source_tier', 'Source tier', TIERS]].map(([field, label, options]) =>
          <label key={field} className="text-sm">{label}<select value={form[field]} onChange={e => update(field, e.target.value)} className="block mt-1 w-full rounded bg-[#1B1E21] border border-[#363a40] p-2">
            {options.map(value => <option key={value}>{value}</option>)}
          </select></label>)}
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.enabled} onChange={e => update('enabled', e.target.checked)} />Enabled (validates RSS before activation)</label>
        <p className="text-xs text-[#A7ABB0] sm:col-span-2">New sources start disabled. Test RSS makes one bounded feed check without AI generation. Existing source quality scores and history are preserved.</p>
        <div className="flex flex-wrap gap-4 sm:col-span-2">
          <button type="button" onClick={test} className="text-[#FFB347]">Test RSS</button>
          <button type="submit" className="text-[#3ecf8e]">{busy ? 'Working…' : 'Save Source'}</button>
          <button type="button" onClick={onCancel}>Cancel</button>
        </div>
      </fieldset>
      {feedback && <p role="status" className="mt-3 text-sm text-[#FFB347] break-words">{feedback}</p>}
    </form>
  </section>;
}
